import { PERMISSIONS, type Permission } from '@repo/contracts';

/**
 * Training has no app gate: anyone signed in sees My training and My
 * certificates. These are the permissions that make a role a training role,
 * the ones the role switcher and the subtitle count.
 */
export const TRAINING_ADMIN_PERMISSIONS: readonly Permission[] = [
  PERMISSIONS.questionnaireRead,
  PERMISSIONS.questionnaireCreate,
  PERMISSIONS.questionnaireUpdate,
  PERMISSIONS.questionnaireDelete,
  PERMISSIONS.questionnaireManage,
  PERMISSIONS.trainingGroupRead,
  PERMISSIONS.trainingGroupCreate,
  PERMISSIONS.trainingGroupUpdate,
  PERMISSIONS.trainingGroupDelete,
  PERMISSIONS.trainingGroupManage,
  PERMISSIONS.trainingAssignmentRead,
  PERMISSIONS.trainingAssignmentCreate,
  PERMISSIONS.trainingAssignmentUpdate,
  PERMISSIONS.trainingAssignmentManage,
  PERMISSIONS.trainingAttemptApprove,
  PERMISSIONS.certificateRead,
  PERMISSIONS.certificateManage,
  PERMISSIONS.trainingSettingsRead,
  PERMISSIONS.trainingSettingsUpdate,
  PERMISSIONS.trainingSettingsManage,
];
